import { Dispatch, Reducer, useCallback, useReducer } from 'react'
import { Constants } from '@/assets'
import { getCurrentTimeFormatted } from './utils'

function useLoggedReducer<State, Action extends { type: string }>(
  reducer: Reducer<State, Action>,
  initialState: State,
  logFilter = /.*/,
  initializer?: undefined,
): [State, Dispatch<Action>] {
  return useReducer(
    useCallback((state: State, action: Action) => {
      const next = reducer(state, action)
      if (Constants.enableReducerLogger && logFilter.test(action.type)) {
        console.groupCollapsed(
          `%cEMT Reducer: %c${action.type} %cat ${getCurrentTimeFormatted()}`,
          'color: grey; font-weight: bold;',
          'color: black; font-weight: bold;',
          'color: lightblue; font-weight: lighter;',
        )
        console.log('%cPrevious State:', 'color: #9E9E9E; font-weight: 700;', state)
        console.log('%cAction:', 'color: #00A7F7; font-weight: 700;', action)
        console.log('%cNext State:', 'color: #47B04B; font-weight: 700;', next)
        console.groupEnd()
      }
      return next
    }, []),
    initialState,
    initializer,
  )
}

export default useLoggedReducer
